<template>
    <div :class="priceBadgeClass">+ {{ price }} C</div>
</template>

<script>
export default {
    props: {
        price: {
            type: Number,
            default: 0,
        },
        isActive: {
            type: Boolean,
        },
    },
    computed: {
        priceBadgeClass: function () {
            return this.isActive ? 'price-badge-selected-xl' : 'price-badge-not-selected-xl';
        },
    },
};
</script>

<style lang="scss" scoped>
//Extend
.price-badge {
    padding: 0 8px;
    border-radius: 4px;
    font-size: 12px;
    display: block;
    height: 16px;
    line-height: 16px;
    position: absolute;
    left: 16px;
    bottom: -8px;
    @media (max-width: 900px) {
        position: relative;
        margin-left: 8px;
        left: auto;
        bottom: auto;
    }
}
.price-badge {
    &-selected-xl {
        @extend .price-badge;
        background-color: $Accent-Color;
        color: #fff;
        font-weight: bold;
    }
    &-not-selected-xl {
        @extend .price-badge;
        color: $Secondary-Text-Color;
        background-color: $Gray-Color;
    }
}
</style>
